import ConfProduct from "./ConfProduct";
export default ConfProduct;
